import { render } from "./CustomColorsContainer.vue?vue&type=template&id=b5dbe376"
import script from "./CustomColorsContainer.vue?vue&type=script&lang=js"
export * from "./CustomColorsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__